export default "__VITE_ASSET__DO94S1I3__"